import { useLiveData, useServices } from '@toeverything/infra';
import { SecurityCheckIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import type { CSSProperties, ReactNode } from 'react';
import { useMemo } from 'react';

import { AuthService } from '../modules/cloud';

export const useIsAdmin = (): boolean | null => {
  const { authService } = useServices({
    AuthService,
  });

  const account = useLiveData(authService.session.account$);

  return useMemo(() => {
    if (!account) {
      return null;
    }
    return account.info?.isAdmin ?? false;
  }, [account]);
};

const badgeBaseStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: 'auto',
  flexShrink: 0,
};

interface BadgeProps {
  style?: CSSProperties;
}

export const AdminBadge = ({ style }: BadgeProps): ReactNode => {
  return (
    <HugeiconsIcon
      icon={SecurityCheckIcon}
      width={18}
      height={18}
      strokeWidth={2.5}
      style={{ ...badgeBaseStyle, color: 'rgba(220, 38, 38, 1)', ...style }}
    />
  );
};

interface WrapperProps {
  children: ReactNode;
}

export const AdminOnlyWrapper = ({ children }: WrapperProps): ReactNode => {
  const isAdmin = useIsAdmin();
  if (!isAdmin) return null;
  return <>{children}</>;
};
